import React from 'react'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { NavLogoIcon } from '../Icons/NavLogo'

import { LANDING, QUIZZES } from 'src/constants/routes'
import { iRootState } from 'src/store'

const stateSelector = (state: iRootState) => ({
  isUserLoggedIn: state.user.data ? true : false,
  hasProfileComplete: state.user.data?.profileComplete,
})
export const LogoLink: React.FC = () => {
  const { isUserLoggedIn, hasProfileComplete } = useSelector(stateSelector)

  return (
    <Link to={isUserLoggedIn && hasProfileComplete ? QUIZZES : LANDING}>
      <NavLogoIcon />
    </Link>
  )
}
